/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_2_LabelInputs */

const en_svc_agents_art_2_label = /** @type {(inputs: Svc_Agents_Art_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM record created`)
};

const lv_svc_agents_art_2_label = /** @type {(inputs: Svc_Agents_Art_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM ieraksts izveidots`)
};

/**
* | output |
* | --- |
* | "CRM record created" |
*
* @param {Svc_Agents_Art_2_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_2_label = /** @type {((inputs?: Svc_Agents_Art_2_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_2_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_2_label(inputs)
	return en_svc_agents_art_2_label(inputs)
});